import { ChangeDetectionStrategy, Component, Input, ChangeDetectorRef } from '@angular/core';
import { Onderneming } from '../models/Onderneming';
import { AuthService } from '../services/auth.service';
import { createCloudStorageUrl } from '../shared/util';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  logoUrl: string | null = null;

  constructor(public authService: AuthService,  private cd: ChangeDetectorRef,) {
  }

  private _onderneming: Onderneming;

  get onderneming(): Onderneming {
    return this._onderneming;
  }

  @Input() set onderneming(value: Onderneming) {
    this._onderneming = value;
    this.cd.markForCheck();
    this.logoUrl = createCloudStorageUrl('/logo-niet-gevonden.png');
    if(value.logo_id != null &&  value.logo_id.trim() != "")
    {
      this.logoUrl = createCloudStorageUrl('/' + value.logo_id);
    }
    
  }

  // gebruiker uitloggen
  logout(): void {
    this.authService.SignOut();
  }
}
